<script setup>
const props = defineProps({
    oldValue: String,
    newValue: String
})
</script>

<template>
    <i class="d-flex align-items-center small">
        modified
    </i>
</template>